// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumLock-cls1___af80e0c25937a186080","cls2":"PremiumLock-cls2___6e6f904580e31b8e22a PremiumLock-cls1___af80e0c25937a186080"};